import {Box, Typography} from "@mui/material";

/**
 * Bloc encadré utilisé pour regrouper visuellement une famille d'options
 * dans le panneau "Plus d'options" du formulaire QR code.
 */
function OptionSection({title, children, sx}) {
    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                ...sx,
            }}
        >
            {title && (
                <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{textTransform: 'uppercase', letterSpacing: 0.6, fontWeight: 600}}
                >
                    {title}
                </Typography>
            )}
            {children}
        </Box>
    );
}

export default OptionSection;
